import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { QuoteLink } from "./QuoteLink";
import { api, getSettings, FALLBACK_SETTINGS } from "../api";
import { useLang, UI } from "../i18n";

export function Footer() {
  const [routes, setRoutes] = useState([]);
  const [contact, setContact] = useState(FALLBACK_SETTINGS.contact);
  const { lang, prefix } = useLang();
  const s = UI[lang];

  useEffect(() => {
    api.get("/routes", { params: { lang } }).then((r) => setRoutes(r.data)).catch(() => {});
    getSettings().then((st) => setContact(st.contact));
  }, [lang]);

  return (
    <footer className="bg-midnight text-champagne/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 grid gap-12 md:grid-cols-4">
        <div className="space-y-4">
          <Logo dark />
          <p className="text-sm leading-relaxed text-champagne/60">{s.footer_blurb}</p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#A9C29A]">DEFRA Type 2 Authorised</p>
        </div>
        <div>
          <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-[#A9C29A] mb-4">{s.footer_routes}</h3>
          <ul className="space-y-2 text-sm">
            {routes.map((r) => (
              <li key={r.slug}>
                <Link to={`${prefix}/routes/${r.slug}`} className="hover:text-[#A9C29A] transition-colors" data-testid={`footer-route-${r.slug}`}>
                  {r.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-[#A9C29A] mb-4">{s.footer_explore}</h3>
          <ul className="space-y-2 text-sm">
            <li><QuoteLink testid="footer-quote-link" className="hover:text-[#A9C29A] transition-colors">{s.footer_book}</QuoteLink></li>
            <li><Link to={`${prefix}/blog`} className="hover:text-[#A9C29A] transition-colors">{s.footer_blog}</Link></li>
            <li><Link to={`${prefix}/resources`} className="hover:text-[#A9C29A] transition-colors" data-testid="footer-resources-link">{lang === "fr" ? "Ressources" : "Resources"}</Link></li>
            <li><a href={`${prefix}/#faq`} className="hover:text-[#A9C29A] transition-colors">FAQ</a></li>
          </ul>
        </div>
        <div>
          <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-[#A9C29A] mb-4">{s.footer_contact}</h3>
          <ul className="space-y-2 text-sm">
            <li><a href={`https://wa.me/${contact.whatsapp}`} target="_blank" rel="noopener noreferrer" className="hover:text-[#A9C29A] transition-colors">WhatsApp</a></li>
            <li><a href={`mailto:${contact.email || "pettaxilondon@gmail.com"}`} className="hover:text-[#A9C29A] transition-colors">{contact.email || "pettaxilondon@gmail.com"}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-champagne/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-champagne/70">
          <span>© 2026 Pet Taxi London · pettaxi.london</span>
          <span>{s.footer_bottom_routes}</span>
        </div>
      </div>
    </footer>
  );
}
